<template>
  <div class="flex flex-col flex-1 min-h-0 h-full w-full">
  <!-- SEO específico para búsqueda de colivings -->
  <ColivingSearchSEO :search-location="getLocationDisplay()" :search-results="searchResults"
    :search-performed="searchPerformed" :current-city="currentCity" :is-city-specific="!!currentCity"
    :max-price="filters.maxPrice" :price-slug="currentPriceSlug" :current-provider="currentProvider"
    :is-provider-search="isProviderSearch" :total-results="totalResults"
    :search-results-for-schema="searchResults.slice(0, 10)" />

  <ErrorBoundary
    class="flex flex-col flex-1 min-h-0 h-full w-full"
    error-title="Error de búsqueda de colivings"
    error-message="Ha ocurrido un error al buscar colivings"
  >
    <!-- PREVIEW AdSense (local) — desactivado para prod; ver AD_PREVIEW_ENABLED en config/adPreview.js
    <div
      v-if="showAdPreview"
      class="fixed top-14 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-600 text-white text-[11px] font-medium shadow-lg pointer-events-none"
    >
      <span class="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
      Preview banners AdSense · solo desarrollo
    </div>
    -->

    <SearchPageLayout
      ref="searchPageLayoutRef"
      class="flex flex-col flex-1 min-h-0 min-w-0"
      v-model:selected-locations="selectedLocations"
      v-model:filters="filters"
      v-model:selected-top-city="selectedTopCity"
      v-model:show-desktop-map="showDesktopMap"
      v-model:show-advanced-filters="showAdvancedFilters"
      v-model:show-seo-content="showSeoContent"
      v-model:is-mobile-map-view-active="isMobileMapViewActive"
      v-model:active-pill-dropdown="activePillDropdown"
      v-model:show-location-dropdown="showLocationDropdown"
      v-model:show-location-dropdown-mobile="showLocationDropdownMobile"
      :region-id="regionId"
      :current-city="currentCity"
      :lead-capture-city="leadCaptureCity"
      :breadcrumb-items="breadcrumbItems"
      :seo-h1-title="seoH1Title"
      :current-city-blog-link="currentCityBlogLink"
      :available-locations="availableLocations"
      :top-city-options="topCityOptions"
      :is-loading="isLoading"
      :is-loading-map-results="isLoadingMapResults"
      :search-error="searchError"
      :search-results="searchResults"
      :map-search-results="mapSearchResults"
      :search-performed="searchPerformed"
      :highlighted-result-id="highlightedResultId"
      :saved-coliving-ids="savedColivingIds"
      :has-more-pages="hasMorePages"
      :is-loading-more="isLoadingMore"
      :total-results="totalResults"
      :list-page="listPage"
      :available-providers="availableProviders"
      :pill-stay-options="pillStayOptions"
      :pill-stay-label="pillStayLabel"
      :pill-price-options-for-quick="pillPriceOptionsForQuick"
      :pill-price-label="pillPriceLabel"
      :pill-more-count="pillMoreCount"
      :pill-more-active="pillMoreActive"
      :get-active-filters-count="getActiveFiltersCount"
      :show-lead-capture-cta="showLeadCaptureCta"
      :operators-in-city-count="operatorsInCityCount"
      :has-lead-session-profile="hasLeadSessionProfile"
      :current-user="currentUser"
      :is-provider-search="isProviderSearch"
      :current-provider="currentProvider"
      :current-provider-content="currentProviderContent"
      :current-city-content="currentCityContent"
      :seo-h2-title="seoH2Title"
      :visible-faqs="visibleFaqs"
      :is-student-mode="isStudentMode"
      :student-hub-cities="studentHubCities"
      :student-hub-seo-content="studentHubSeoContent"
      @submit="performSearch"
      @apply-location-filter="applyLocationFilter"
      @apply-location-filter-mobile="applyLocationFilterMobile"
      @apply-advanced-filters="applyAdvancedFilters"
      @clear-filters="clearAdvancedFilters"
      @partner-services="handlePartnerServicesClick"
      @lead-search="openLeadModalSearch"
      @lead-listing="openLeadModalListing"
      @lead-change-data="clearLeadSessionAndEdit"
      @highlight-marker="highlightMarker"
      @unhighlight-marker="unhighlightMarker"
      @sort-change="handleSortChange"
      @toggle-save="handleToggleSaveColiving"
      @list-page-change="onListPageChange"
      @prefetch-map="requestMapResults"
      @highlight-result="highlightResult"
      @map-bounds-update="handleMapBoundsUpdate"
      @mobile-marker-click="handleMobileMarkerClick"
      @mobile-map-bounds-update="handleMobileMapBoundsUpdate"
      @toggle-pill-dropdown="togglePillDropdown"
      @select-pill-stay="selectPillStay"
      @select-pill-price="selectPillPrice"
      @quick-toggle="quickToggleFilter"
      @save-search="showSaveSearchModal = true"
    />


    <SearchLeadHost
      :is-partner-modal-visible="isPartnerModalVisible"
      :is-lead-modal-visible="isLeadModalVisible"
      :is-hive-lead-modal-visible="isHiveLeadModalVisible"
      :lead-modal-mode="leadModalMode"
      :lead-modal-coliving="leadModalColiving"
      :hive-lead-coliving="hiveLeadColiving"
      :city="leadCaptureCity || ''"
      :search-filters="getLeadSearchFilters()"
      :operators-count="operatorsInCityCount"
      :search-results="searchResults"
      :user-id="currentUser?.uid || ''"
      @close-partner="isPartnerModalVisible = false"
      @apply-natural-filters="applyNaturalSearchFilters"
      @request-scraped-lead="openLeadModalListing"
      @open-partner-services="handlePartnerServicesClick"
      @close-lead="closeLeadModal"
      @lead-submitted="handleLeadSubmitted"
      @close-hive-lead="closeHiveLeadModal"
      @hive-lead-submitted="handleHiveLeadSubmitted"
    />

    <SaveSearchModal
      :is-visible="showSaveSearchModal"
      :city-label="leadCaptureCity || ''"
      :search-filters="{ locations: selectedLocations, ...filters }"
      :search-summary="saveSearchSummary"
      :total-results="totalResults"
      @close="showSaveSearchModal = false"
      @saved="showSaveSearchModal = false"
    />
  </ErrorBoundary>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted, onUnmounted, unref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAnalytics } from '@/composables/useAnalytics';
import { useRegion } from '@/composables/useRegion';
import { SLUG_TO_NAME, getRegionForCitySlug } from '../../../shared/locationRegistry.cjs';
import { LONDON_NEIGHBORHOODS } from '../../../shared/londonNeighborhoods.cjs';
import { parseListPageFromQuery } from '@/utils/searchListPagination';
import { applyPbsaFiltersIfResidencias } from '@/utils/residenciasSearch';
import { isAccommodationTypeLandingPath } from '@/utils/accommodationTypeLandings';
import ErrorBoundary from './ErrorBoundary.vue';
import SearchPageLayout from './search/SearchPageLayout.vue';
import SearchLeadHost from './search/SearchLeadHost.vue';
import SaveSearchModal from './SaveSearchModal.vue';
import ColivingSearchSEO from './ColivingSearchSEO.vue';
import { useColivingSearchEngine } from '@/composables/useColivingSearchEngine';
import { useSearchLeadOrchestrator } from '@/composables/useSearchLeadOrchestrator';
import { useSearchSeoContent, NYC_CITIES, LONDON_AREAS } from '@/composables/useSearchSeoContent';
import { useSearchRouteSync } from '@/composables/useSearchRouteSync';
import { useSearchFiltersSetup } from '@/composables/useSearchFiltersSetup';
import { useSearchFilterControls } from '@/composables/useSearchFilterControls';
import { useNotifications } from '@/composables/useNotifications.js';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { subscribeSavedColivings, toggleSaveColiving } from '../services/savedColivingsService';
import { getCachedUserPreferences, cacheUserPreferences } from '../services/recommendationService';
import { usePageTracking } from '@/composables/usePageTracking';
// Preview AdSense (local): import { isAdPreviewEnabled } from '@/config/adPreview';

const { t, locale } = useI18n();
const { toastMessage, showToast } = useNotifications();
const route = useRoute();
const router = useRouter();
const auth = getAuth();

// Preview AdSense (local): const showAdPreview = computed(() => isAdPreviewEnabled(route));

// Composable de región
const { regionId, regionCurrency, initializeRegion, setRegion } = useRegion();

// ── Tracking de visitas al buscador ──────────────────────────────────────────
// Captura cada sesión en /encuentratucoliving y /findyourcoliving (hub + ciudad).
// city se resuelve en el momento del sendBeacon para incluir la ciudad activa.
usePageTracking('search', {
  city: () => route.params.city || route.params.segment || null,
});

// Opciones de precio dinámicas según región (usadas en mobile y en SEO copy)
const mobilePriceOptions = computed(() => {
  if (regionId.value === 'us') return [1200, 1800, 2500, 3500, 5000];
  if (regionId.value === 'uk') return [1000, 1200, 1500, 1800, 2200];
  return [500, 700, 900, 1200, 1500];
});

const formatMobilePrice = (value) => {
  const currency = regionCurrency.value || '€';
  const perMonth = regionId.value === 'es' ? '/mes' : '/mo';
  if (currency === '$') return `$${value.toLocaleString()}${perMonth}`;
  if (currency === '£') return `£${value.toLocaleString()}${perMonth}`;
  return `${value.toLocaleString('es-ES')}€${perMonth}`;
};

// Ciudad principal seleccionada (solo para regiones UK/US)
// 'new-york' | 'london' | null
const selectedTopCity = ref(
  regionId.value === 'us' ? 'new-york'
  : regionId.value === 'uk' ? 'london'
  : null
);

// Opciones de ciudad de primer nivel (solo se muestran para UK/US)
const topCityOptions = computed(() => {
  if (regionId.value === 'es') return null;
  return [
    { id: 'new-york', label: 'New York', flag: '🇺🇸' },
    { id: 'london', label: 'London', flag: '🇬🇧' }
  ];
});

// Detectar si estamos en modo estudiante (desde la ruta)
const isStudentMode = computed(() => {
  return route.meta?.isStudentSearch === true
    || route.path.startsWith('/residencias')
    || route.path.startsWith('/residencias-estudiantes');
});

// Estado reactivo
const isLoading = ref(false);
const searchResults = ref([]);
const mapSearchResults = ref([]);
const searchError = ref('');
const searchPerformed = ref(false);

// OPTIMIZACIÓN: Pagination del backend (carga en dos fases)
const currentPage = ref(1);
// Página visible en la lista (12 cards/página), sincronizada con ?page=N en la URL (Opción B: noindex)
const listPage = ref(parseListPageFromQuery(route.query.page));
const hasMorePages = ref(false);
const isLoadingMore = ref(false);
const isLoadingMapResults = ref(false); // Indica si estamos cargando resultados adicionales para el mapa
const mapLoadVersion = ref(0); // Contador de versión para invalidar loadMapResults de búsquedas anteriores

// ── Tracking de comportamiento ────────────────────────────────────────────
const _pageLoadTs = Date.now(); // timestamp de montaje del componente
const _firstSearchDone = ref(false); // ¿ya se disparó el tracker de primera búsqueda?
const _lastSearchHadClick = ref(true); // ¿el último resultado de búsqueda tuvo algún click?
const _lastSearchCity = ref(''); // ciudad de la última búsqueda completada (para search_no_click)
const totalResults = ref(0); // Total de resultados disponibles
const searchPageLayoutRef = ref(null);
const highlightedResultId = ref(null);
const currentUser = ref(null);
const isMobileMapViewActive = ref(false);
const showDesktopMap = ref(false);
// SEO content visible en páginas de ciudad Y en hubs (/encuentratucoliving, /findyourcoliving)
// para que el prerendering capture HTML estático indexable (FAQs + guía + enlaces internos).
const isMarketplaceHubPath = () => {
  const p = route.path.toLowerCase();
  return p === '/encuentratucoliving' || p === '/findyourcoliving' || p === '/residencias';
};
const showSeoContent = ref(
  !!route.params.city || isMarketplaceHubPath() || isAccommodationTypeLandingPath(route.path),
);

// Estado para colivings guardados
const savedColivingIds = ref(new Set());
let unsubscribeSavedColivings = null;

// Estado para preferencias del usuario (para recomendaciones)
const userPreferences = ref(null);
const hasLoadedPreferences = ref(false);

// Estados del dropdown de ubicaciones
const showLocationDropdown = ref(false);
const showLocationDropdownMobile = ref(false);
const showSaveSearchModal = ref(false);

// Provincias disponibles con colivings (dinámicas según región)
const availableLocations = computed(() => {
  // Para España: todas las ciudades actuales
  if (regionId.value === 'es') {
    return [
      'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Málaga', 'Las Palmas',
      'Tenerife', 'Salamanca', 'Alicante', 'Bilbao', 'Granada', 'Zaragoza',
      'Pamplona'
    ]
  }
  
  // Para US: boroughs de Nueva York + área metro (coinciden con propertyLocation en los scrapers)
  if (regionId.value === 'us') {
    return ['Manhattan', 'Brooklyn', 'Queens', 'Jersey City', 'Williamsburg', 'Astoria']
  }
  
  // Para UK: barrios de Londres (78 propertyLocation activos en Firestore — shared/londonNeighborhoods.cjs)
  if (regionId.value === 'uk') {
    return [...LONDON_NEIGHBORHOODS];
  }
  
  // Por defecto: España
  return [
    'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Málaga', 'Las Palmas',
    'Tenerife', 'Salamanca', 'Alicante', 'Bilbao', 'Granada', 'Zaragoza',
    'Pamplona'
  ]
});




const cityMapping = SLUG_TO_NAME;

const {
  filters,
  selectedLocations,
  availableProviders,
  getInitialFilters,
  getDefaultSortBy,
  getPriceFromSlug,
  currentPriceSlug,
} = useSearchFiltersSetup({
  route,
  regionId,
  cityMapping,
  availableLocations,
});


const { trackSearch, trackZeroResults, trackLoadMore, trackFilterChange, trackAdvancedFiltersToggle, trackSearchNoClick, trackFirstSearchDelay, trackShareColiving } = useAnalytics();

// Estado para controlar la visibilidad de filtros avanzados
const showAdvancedFilters = ref(false);

// Flag para evitar que el watch de región se ejecute durante la inicialización
const isInitializing = ref(true);
const activePillDropdown = ref(null);

// Watcher para trackear toggle de filtros avanzados
watch(showAdvancedFilters, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    trackAdvancedFiltersToggle({
      isOpen: newValue,
      ciudad: selectedLocations.value.join(',') || 'todas'
    });
  }
});


function resolveListComponent(exposedRef) {
  if (!exposedRef) return null;
  return typeof exposedRef.scrollToCard === 'function' ? exposedRef : exposedRef.value;
}

// Métodos de manejo del mapa y resultados
const highlightResult = (id) => {
  highlightedResultId.value = id;
  const layout = searchPageLayoutRef.value;
  const useDesktopList = unref(layout?.isDesktopLayout) ?? window.innerWidth >= 1024;
  const listRef = useDesktopList
    ? resolveListComponent(layout?.searchResultsListRef)
    : resolveListComponent(layout?.searchResultsListRefMobile);
  listRef?.scrollToCard?.(id);
};

const highlightMarker = (id) => {
  highlightedResultId.value = id;
};

const unhighlightMarker = () => {
  highlightedResultId.value = null;
};

const handleMapBoundsUpdate = (bounds) => {
  // Map bounds updated for desktop view
};

const handleMobileMarkerClick = (id) => {
  highlightedResultId.value = id;
  isMobileMapViewActive.value = false;
  nextTick(() => {
    const listRef = resolveListComponent(searchPageLayoutRef.value?.searchResultsListRefMobile);
    listRef?.scrollToCard?.(id);
  });
};

const handleMobileMapBoundsUpdate = (bounds) => {
  // Map bounds updated for mobile view
};

// Aplicar filtros detectados por el widget de búsqueda natural con IA
const applyNaturalSearchFilters = (detected) => {
  // Resetear filtros primero
  const initial = getInitialFilters();
  Object.assign(filters.value, initial);

  // Ubicaciones
  if (detected.locations?.length > 0) {
    selectedLocations.value = detected.locations.filter(loc =>
      availableLocations.value.includes(loc)
    );
  }

  // Precio máximo
  if (detected.maxPrice) {
    filters.value.maxPrice = detected.maxPrice;
  }

  // Estancia mínima
  if (detected.maxMinimumStay) {
    filters.value.maxMinimumStay = detected.maxMinimumStay;
  }

  // Políticas
  if (detected.policies) {
    if (detected.policies.pets) filters.value.policies.pets = true;
    if (detected.policies.couples) filters.value.policies.couples = true;
  }

  // Servicios
  if (detected.services) {
    if (detected.services.internet) filters.value.services.internet = true;
    if (detected.services.cleaning) filters.value.services.cleaning = true;
    if (detected.services.allIncluded) filters.value.services.allIncluded = true;
  }

  // Baños
  if (detected.minBathrooms) {
    filters.value.minBathrooms = detected.minBathrooms;
  }

  // Tipo de alojamiento
  if (detected.accommodationType) {
    if (detected.accommodationType.building) filters.value.accommodationType.building = true;
    if (detected.accommodationType.apartment) filters.value.accommodationType.apartment = true;
  }

  // Estudiantes
  if (detected.forStudents) {
    filters.value.forStudents = true;
  }

  // Proveedores
  if (detected.providers?.length > 0) {
    filters.value.providers = detected.providers;
  }

  // Ejecutar búsqueda con los nuevos filtros
  performSearch();
};

// Función para cerrar los dropdowns al hacer click fuera
const handleClickOutside = (event) => {
  // Cerrar dropdown de ubicaciones (desktop)
  if (showLocationDropdown.value) {
    const locationDropdown = document.querySelector('[data-location-dropdown-desktop]');
    const locationButton = event.target.closest('[data-location-button-desktop]');
    if (locationDropdown && !locationDropdown.contains(event.target) && !locationButton) {
      showLocationDropdown.value = false;
    }
  }
  // Cerrar dropdown de ubicaciones (mobile)
  if (showLocationDropdownMobile.value) {
    const locationPanel = document.querySelector('[data-location-panel-mobile]');
    const locationButton = event.target.closest('[data-location-button-mobile]');
    if (locationPanel && !locationPanel.contains(event.target) && !locationButton) {
      showLocationDropdownMobile.value = false;
    }
  }
  // Cerrar pill dropdowns (precio, estancia, tipo) si el clic fue fuera
  if (activePillDropdown.value) {
    const clickedPill = event.target.closest('[data-pill]');
    if (!clickedPill) {
      activePillDropdown.value = null;
    }
  }
};

// Ciudad desde slug de URL (SEO / breadcrumbs — solo España u rutas /encuentratucoliving/:city)
const currentCity = computed(() => {
  const cityParam = route.params.city;
  return cityParam && cityMapping[cityParam.toLowerCase()]
    ? cityMapping[cityParam.toLowerCase()]
    : null;
});

// Ciudad para Forma 1 (lead capture): URL, filtro único, o metro NY/London por región
const leadCaptureCity = computed(() => {
  if (currentCity.value) return currentCity.value;
  if (selectedLocations.value.length === 1) return selectedLocations.value[0];
  if (regionId.value === 'us') return 'New York';
  if (regionId.value === 'uk') return 'London';
  return null;
});

const saveSearchSummary = computed(() => {
  const parts = [];
  if (currentCity.value) parts.push(currentCity.value);
  else if (selectedLocations.value.length) parts.push(selectedLocations.value.join(', '));
  if (filters.value.maxPrice) parts.push(`hasta ${filters.value.maxPrice}€/mes`);
  if (filters.value.maxMinimumStay) {
    const n = filters.value.maxMinimumStay;
    const stayLabel = n === 1
      ? t('colivingSearch.pills.stayOptions.from1')
      : t(`colivingSearch.pills.stayOptions.maxMin${n}`);
    parts.push(stayLabel);
  }
  if (totalResults.value) parts.push(`${totalResults.value} resultados`);
  return parts.join(' · ') || 'Todos los alojamientos';
});

const {
  performSearch,
  requestMapResults,
  onListPageChange,
  applyInitialUrlPage,
  sortSearchResults,
  ensureDataForListPage,
} = useColivingSearchEngine({
  route,
  router,
  locale,
  regionId,
  filters,
  selectedLocations,
  currentUser,
  currentCity,
  searchResults,
  searchPerformed,
  searchError,
  isLoading,
  isLoadingMore,
  isLoadingMapResults,
  mapLoadVersion,
  currentPage,
  listPage,
  hasMorePages,
  totalResults,
  isMobileMapViewActive,
  showDesktopMap,
  mapSearchResults,
  isInitializing,
  userPreferences,
  showToast,
  trackSearch,
  trackZeroResults,
  trackLoadMore,
  trackSearchNoClick,
  trackFirstSearchDelay,
  _firstSearchDone,
  _lastSearchHadClick,
  _lastSearchCity,
  _pageLoadTs,
});

watch([showDesktopMap, isMobileMapViewActive], ([desktopMap, mobileMap]) => {
  if (desktopMap || mobileMap) {
    requestMapResults();
  }
});

const handleSortChange = (newSortOrder) => {
  filters.value.sortBy = newSortOrder;

  if (searchResults.value.length > 0) {
    sortSearchResults();
  }
  if (showDesktopMap.value || isMobileMapViewActive.value) {
    requestMapResults({ force: true });
  }
};

const {
  pillPriceOptionsForQuick,
  pillPriceLabel,
  pillStayOptions,
  pillStayLabel,
  pillMoreCount,
  pillMoreActive,
  togglePillDropdown,
  selectPillPrice,
  selectPillStay,
  quickToggleFilter,
  applyLocationFilter,
  applyLocationFilterMobile,
  applyAdvancedFilters,
  getLocationDisplay,
  getActiveFiltersCount,
  clearAdvancedFilters,
} = useSearchFilterControls({
  t,
  route,
  router,
  regionId,
  filters,
  selectedLocations,
  activePillDropdown,
  showAdvancedFilters,
  showLocationDropdown,
  showLocationDropdownMobile,
  mobilePriceOptions,
  formatMobilePrice,
  trackFilterChange,
  performSearch,
});


const {
  isPartnerModalVisible,
  isLeadModalVisible,
  isHiveLeadModalVisible,
  leadModalMode,
  leadModalColiving,
  hiveLeadColiving,
  handlePartnerServicesClick,
  openLeadModalSearch,
  openLeadModalListing,
  openLeadModalExit,
  closeLeadModal,
  closeHiveLeadModal,
  handleLeadSubmitted,
  handleHiveLeadSubmitted,
  clearLeadSessionAndEdit,
  getLeadSearchFilters,
  showLeadCaptureCta,
  operatorsInCityCount,
  hasLeadSessionProfile,
} = useSearchLeadOrchestrator({
  filters,
  leadCaptureCity,
  searchPerformed,
  searchResults,
  currentUser,
  showToast,
  t,
});


// Computed para verificar si estamos en una búsqueda por proveedor
const isProviderSearch = computed(() => {
  return route.meta?.isProviderSearch === true || !!route.params.provider;
});

const currentProvider = computed(() => route.params.provider || null);

const {
  currentCityBlogLink,
  seoH1Title,
  seoH2Title,
  currentCityContent,
  currentProviderContent,
  visibleFaqs,
  breadcrumbItems,
  studentHubCities,
  studentHubSeoContent,
} = useSearchSeoContent({
  route,
  t,
  regionId,
  filters,
  currentCity,
  isStudentMode,
  isProviderSearch,
  currentProvider,
  currentPriceSlug,
});

useSearchRouteSync({
  route,
  regionId,
  filters,
  selectedLocations,
  selectedTopCity,
  listPage,
  searchResults,
  totalResults,
  showSeoContent,
  isInitializing,
  isLoading,
  isLoadingMapResults,
  mapLoadVersion,
  isStudentMode,
  currentProvider,
  currentCity,
  cityMapping,
  getDefaultSortBy,
  getPriceFromSlug,
  setRegion,
  performSearch,
  ensureDataForListPage,
});

// Función para cargar preferencias del usuario desde Firestore o localStorage
const loadUserPreferences = async (userId) => {
  // Si ya cargamos las preferencias para esta sesión, no volver a hacerlo
  if (hasLoadedPreferences.value) return;

  try {
    // Primero intentar desde localStorage (más rápido)
    const cachedPrefs = getCachedUserPreferences();
    if (cachedPrefs) {
      userPreferences.value = cachedPrefs;
      applyUserPreferencesToFilters(cachedPrefs);
    }

    // Si hay usuario logueado, cargar desde Firestore (fuente de verdad)
    if (userId) {
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const prefs = {
          preferredCity: userData.preferredCity || '',
          isStudent: userData.isStudent || false,
          monthlyIncome: userData.monthlyIncome || null
        };

        userPreferences.value = prefs;

        // Actualizar caché local
        cacheUserPreferences(prefs);

        // Aplicar preferencias a los filtros (solo si no hay ciudad en URL)
        if (!route.params.city) {
          applyUserPreferencesToFilters(prefs);
        }
      }
    }

    hasLoadedPreferences.value = true;
  } catch (error) {
    console.error('Error cargando preferencias del usuario:', error);
  }
};

// Función para aplicar preferencias del usuario a los filtros
const applyUserPreferencesToFilters = (prefs) => {
  if (!prefs) return;

  // Solo aplicar ciudad preferida si:
  // 1. No hay ciudad en la URL
  // 2. No hay ubicaciones ya seleccionadas
  // 3. El usuario tiene una ciudad preferida configurada
  if (!route.params.city && selectedLocations.value.length === 0 && prefs.preferredCity) {
    selectedLocations.value = [prefs.preferredCity];
  }

  // Aplicar filtro de estudiantes si el usuario es estudiante
  if (prefs.isStudent && !filters.value.forStudents) {
    filters.value.forStudents = true;
  }
};

// Función para suscribirse a colivings guardados
const setupSavedColivingsSubscription = (userId) => {
  if (!userId) {
    savedColivingIds.value = new Set();
    return;
  }

  // Desuscribirse de la suscripción anterior si existe
  if (unsubscribeSavedColivings) {
    unsubscribeSavedColivings();
  }

  // Suscribirse a cambios en tiempo real
  unsubscribeSavedColivings = subscribeSavedColivings(userId, (colivings, ids) => {
    savedColivingIds.value = ids;
  });
};

// Función para manejar toggle de guardado
const handleToggleSaveColiving = async (coliving) => {
  // Si no hay usuario logueado, redirigir a registro con applicant preseleccionado
  if (!currentUser.value) {
    // Guardar acción pendiente en sessionStorage
    sessionStorage.setItem('pendingAction', JSON.stringify({
      type: 'save_coliving',
      colivingId: coliving.id,
      colivingData: coliving
    }));
    
    // Guardar la URL actual para redirigir después del registro
    const currentPath = window.location.pathname + window.location.search;
    sessionStorage.setItem('redirectAfterLogin', currentPath);
    
    // Redirigir a signup con userType=applicant
    router.push('/signup?userType=applicant');
    return;
  }

  const isSaved = savedColivingIds.value.has(coliving.id);
  const newState = await toggleSaveColiving(currentUser.value.uid, coliving, isSaved);

  if (newState !== isSaved) {
    showToast(
      newState ? 'Coliving guardado correctamente' : 'Coliving eliminado de guardados',
      newState ? 'success' : 'info'
    );
  }
};

// REGISTRO PROGRESIVO: Ejecutar acción pendiente guardada en sessionStorage
const executePendingAction = async (userId) => {
  const pendingActionStr = sessionStorage.getItem('pendingAction');
  if (!pendingActionStr) return;

  try {
    const pendingAction = JSON.parse(pendingActionStr);

    if (pendingAction.type === 'save_coliving' && pendingAction.colivingId) {
      const { saveColiving } = await import('../services/savedColivingsService');

      // Buscar datos del coliving si no están en la acción pendiente
      let colivingData = pendingAction.colivingData;
      if (!colivingData) {
        // Intentar encontrar el coliving en los resultados actuales
        colivingData = searchResults.value.find(c => c.id === pendingAction.colivingId);
      }

      if (colivingData) {
        await saveColiving(userId, colivingData);
        showToast('¡Coliving guardado! 🎉', 'success');
      }
    }

    // Limpiar acción pendiente
    sessionStorage.removeItem('pendingAction');
  } catch (error) {
    console.error('Error ejecutando acción pendiente:', error);
    sessionStorage.removeItem('pendingAction');
  }
};

// Lifecycle hooks
onMounted(() => {
  // Inicializar región desde localStorage / idioma del navegador (síncrono)
  initializeRegion();

  // Vertical residencias estudiantes = solo España (stock Madrid/Barcelona).
  // Sin esto, Googlebot/prerender (UA en) detecta región US y la búsqueda devuelve 0 resultados.
  if (isStudentMode.value && regionId.value !== 'es') {
    setRegion('es');
  }

  // Forzar región según la ciudad en la URL (p. ej. San Sebastián en /findyourcoliving/
  // debe usar región ES, no US por idioma del navegador).
  const citySlugFromRoute = route.params.city;
  if (citySlugFromRoute) {
    const cityRegion = getRegionForCitySlug(citySlugFromRoute);
    if (cityRegion && regionId.value !== cityRegion) {
      setRegion(cityRegion);
    }
  } else if (NYC_CITIES.has(currentCity.value) && regionId.value !== 'us') {
    setRegion('us');
  } else if (LONDON_AREAS.has(currentCity.value) && regionId.value !== 'uk') {
    setRegion('uk');
  }

  // ─── FASE 1: Búsqueda inmediata (no espera a Auth) ───────────────────────
  // Aplicar preferencias de caché (localStorage) de forma síncrona
  // antes de buscar para que los filtros estén listos.
  const cachedPrefs = getCachedUserPreferences();
  if (cachedPrefs && !route.params.city) {
    userPreferences.value = cachedPrefs;
    // No aplicar ciudad preferida antes de la 1ª petición (hubFast): evita merge lento en móvil.
  }

  if (isStudentMode.value) {
    if (!applyPbsaFiltersIfResidencias(route.path, filters.value) && !filters.value.forStudents) {
      filters.value.forStudents = true;
    }
  }

  // Lanzar la búsqueda de inmediato — sin esperar Firebase Auth.
  // Los resultados NO dependen del usuario (son públicos); el userId
  // solo se usa para mostrar el icono de "guardado" en cada tarjeta,
  // que se actualiza en la Fase 2.
  performSearch(true, true).finally(async () => {
    await applyInitialUrlPage();
    if (cachedPrefs && !route.params.city) {
      applyUserPreferencesToFilters(cachedPrefs);
    }
    nextTick(() => {
      isInitializing.value = false;
    });
  });

  // ─── FASE 2: Personalización (en paralelo, no bloquea la búsqueda) ───────
  const auth = getAuth();
  onAuthStateChanged(auth, async (user) => {
    currentUser.value = user;
    setupSavedColivingsSubscription(user?.uid);

    // Cargar preferencias del servidor (Firestore) solo si hay usuario
    if (user) {
      await loadUserPreferences(user.uid);
      await executePendingAction(user.uid);

      // Si las preferencias del usuario cambian la ciudad y aún no hay
      // ciudad en la URL, relanzar la búsqueda con la ciudad preferida.
      const prefs = userPreferences.value;
      if (
        !isInitializing.value &&
        prefs?.preferredCity &&
        !route.params.city &&
        selectedLocations.value.length === 0
      ) {
        performSearch();
      }
    }
  });

  document.addEventListener('click', handleClickOutside);

  // Punto 3: marcar si el usuario interactúa con una card de resultado
  // Buscamos el atributo data-search-card que añade ContractCard cuando es resultado de búsqueda
  const _markSearchClicked = (e) => {
    const card = e.target?.closest('[data-search-card="true"]');
    if (card) _lastSearchHadClick.value = true;
  };
  document.addEventListener('click', _markSearchClicked, { capture: true });

  // Guardar referencia para limpiarla en onUnmounted
  window._cooliving_markSearchClicked = _markSearchClicked;
});

onUnmounted(() => {
  // Remover listener al desmontar el componente
  document.removeEventListener('click', handleClickOutside);

  // Punto 3: limpiar listener de interacción con cards
  if (window._cooliving_markSearchClicked) {
    document.removeEventListener('click', window._cooliving_markSearchClicked, { capture: true });
    delete window._cooliving_markSearchClicked;
  }

  // Limpiar suscripción de guardados
  if (unsubscribeSavedColivings) {
    unsubscribeSavedColivings();
  }
});
</script>

<style scoped>
.shadow-up {
  box-shadow: 0 -4px 6px -1px rgb(0 0 0 / 0.1), 0 -2px 4px -2px rgb(0 0 0 / 0.1);
}

.shadow-3xl {
  box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.25);
}

/* Ocultar scrollbar solo en contenedores de scroll del buscador (no global *) */
.overflow-y-auto::-webkit-scrollbar {
  display: none;
}

.overflow-y-auto {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

:deep(.h-full) {
  height: 100%;
}

/* Mejoras adicionales para el diseño */
.backdrop-blur-xl {
  backdrop-filter: blur(16px);
}

/* Animación suave para el hover del buscador */
@keyframes searchPulse {

  0%,
  100% {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  50% {
    box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.3);
  }
}

.hover\:shadow-3xl:hover {
  animation: searchPulse 2s ease-in-out infinite;
}
</style>